import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onDeleteProductRes } from "./helper";

const deleteProduct = async (id: number) =>
  axios.delete(Routes.DELETE_PRODUCT + "/" + id);

export const useDeleteProduct = () =>
  useMutation({
    mutationKey: [Keys.DELETE_PRODUCT_MUT],
    mutationFn: deleteProduct,
    onSuccess: onDeleteProductRes,
  });
